<template>
    <v-container>
        <v-row justify="center">
            <v-btn-toggle v-model="select"
                          color="primary"
                          dense
                          group
                          class="my-5">
                <v-btn value="owner" x-large
                       style="font-size: 16px">เจ้าของ
                </v-btn>
                <v-btn value="instead" x-large
                       style="font-size: 16px">รับแทน
                </v-btn>
            </v-btn-toggle>
        </v-row>
        <v-row justify="center" class="mb-5">
            <VueSignaturePad
                    id="signature"
                    width="90%"
                    height="230px"
                    ref="signaturePad"
            />
            <p class="text-center mt-1">
                <v-icon>mdi-pencil</v-icon>
                กรุณาเซ็นชื่อในช่องว่างด้านบน
            </p>
        </v-row>

        <v-row justify="center" class="mb-5 px-5" v-if="select === 'instead'">
            <v-text-field
                    label="ชื่อ-สกุล"
                    v-model="name"
                    :rules="nameRules"
                    required
                    outlined
            ></v-text-field>
            <v-text-field
                    label="เบอร์โทร"
                    v-model="tel"
                    :rules="telRules"
                    type="number"
                    required
                    outlined
            ></v-text-field>
        </v-row>
        <hr class="mb-5">
        <v-row class="mx-3" style="padding: 0">
            <v-col cols="12" style="padding: 0 5% 0 0">
                <v-btn color="green" dark x-large @click="dialog = true" block>
                    <v-icon class="mr-3">mdi-camera-plus</v-icon>
                    ถ่ายรูป
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="mt-7" justify="center">
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>อัพโหลดรูป</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                    </v-toolbar>
                    <v-card-text class="mt-10">
                        <v-container>
                            <v-row justify="center">
                                <v-text-field label="Select Image"
                                              @click='pickFile'
                                              v-model='imageName'
                                              outlined
                                              prepend-icon='mdi-camera'>
                                </v-text-field>
                                <input type="file"
                                       style="display: none"
                                       ref="image"
                                       accept="image/*"
                                       @change="onFilePicked"
                                >
                            </v-row>
                            <v-row justify="center">
                                <v-img :src="imageUrl" v-if="imageUrl"></v-img>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions class="pr-6">
                        <div class="flex-grow-1"></div>
                        <v-btn color="green darken-1" text @click="upload">บันทึก</v-btn>
                        <v-btn color="red darken-1" text @click="dialog = false">ยกเลิก</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog2" max-width="290">
            <v-card>
                <v-card-title class="headline">กรุณาเซ็นชื่อ</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="dialog2 = false">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog3" max-width="290">
            <v-card>
                <v-card-title class="headline">ประเมินความพึงพอใจ</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-row justify="center" class="mb-5">
                        <div class="text-center">
                            <form name="login" action="http://cmis.lpn.co.th/service_evaluation/main/sentEvaluation"
                                  method="post">
                                <input type="hidden" name="nt_runno" :value="nt_runno"/>
                                <input type="hidden" name="username" :value="username"/>
                                <input type="hidden" name="pd_addr" :value="pd_addr"/>
                                <input type="hidden" name="select" :value="select"/>
                                <input type="hidden" name="name" :value="name"/>
                                <input type="hidden" name="url_back_link" :value="url_back_link"/>
                                <input type="hidden" name="service_name" value="Parcel"/>

                                <v-btn color="green darken-1" text type="submit"> ตกลง</v-btn>
                                <v-btn color="red darken-1" text @click="goto('search-parcel')"> ยกเลิก</v-btn>
                            </form>
                        </div>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row class="mb-8">
            <v-spacer></v-spacer>
            <v-btn x-large color="primary" @click="save" minWidth="40%">บันทึก</v-btn>
            <v-spacer></v-spacer>
            <v-btn x-large color="error" @click="undo" minWidth="40%">ยกเลิก</v-btn>
            <v-spacer></v-spacer>
        </v-row>
    </v-container>
</template>

<script>
    import axios from '@/axios';
    import EventBus from '@/EventBus'
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: "CustomerReceiveParcel",
        components: {
            QrcodeVue,
        },
        data() {
            return {
                dataSignature: {
                    img: '',
                    username: JSON.parse(localStorage.getItem('parcel')).user_id
                },
                select: 'owner',
                dialog: false,
                dialog2: false,
                dialog3: false,
                dialog_qr: false,
                imageName: '',
                imageUrl: '',
                imageFile: '',
                hasImage: false,
                image: null,
                name: '',
                tel: '',
                nameRules: [
                    (v) => !!v || 'กรุณากรอกชื่อ',
                ],
                telRules: [
                    (v) => !!v || 'กรุณากรอกเบอร์โทร',
                ],
                nt_runno: this.getLocalItem().nt_runno,
                username: this.getLocalItem().user_id,
                // url_back_link: 'http://localhost:8080//#/receive',
                url_back_link: 'https://mobileapps.lpn.co.th/parcel/#/search-parcel',
                pd_addr: this.getLocalItem().searchText,
                assessment: false,
                valueQR: '',
                sizeQR: 220,
            }
        },
        mounted() {
            window.scrollTo(0, 0)
        },
        methods: {
            undo() {
                this.$refs.signaturePad.clearSignature()
            },
            save() {
                const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
                if (data) {
                    this.dataSignature.img = data
                    if (this.select == 'owner') {
                        this.saveParcelSignature(this.select, null, null)
                    } else {
                        this.saveParcelSignature(this.select, this.name, this.tel)
                    }
                } else {
                    this.dialog2 = true
                }
            },
            upload() {
                this.dataSignature.imgIdCard = this.imageUrl
                this.dialog = false
            },
            pickFile() {
                this.$refs.image.click()
            },
            onFilePicked(e) {
                const files = e.target.files
                if (files[0] !== undefined) {
                    this.imageName = files[0].name
                    if (this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.imageName = ''
                    this.imageFile = ''
                    this.imageUrl = ''
                }
            },
            async saveParcelSignature(rc_type, name, tel) {
                try {
                    console.log('SaveImgSignature', this.dataSignature)
                    axios.post('/SaveImgSignature', this.dataSignature)
                        .then(res => {
                            // console.log('SaveImgSignature', res.data.data.SGN_RUNNO)
                            if (res.data.data.SGN_RUNNO) {
                                let itemSelected = JSON.parse(localStorage.getItem('parcel')).itemSelected
                                this.updateStatusParcel(itemSelected, res.data.data.SGN_RUNNO, rc_type, name, tel)
                            }
                        })
                } catch (err) {
                    console.log(err.message)
                }
            },
            async updateStatusParcel(itemSelected, sgn_runno, rc_type, name, tel) {
                try {
                    // let rc_type = this.select
                    itemSelected.forEach(function (su_runno) {
                        axios.post('/SaveParcel', {
                            su_runno: su_runno,
                            sgn_runno: sgn_runno,
                            rc_type: rc_type,
                            name: name,
                            tel: tel
                        })
                            .then(res => {
                                console.log('updateStatusParcel', res.data)
                            })
                    })
                    this.dialog3 = true
                } catch (err) {
                    console.log(err.message)
                }
            },
            goto(route_name, params) {
                if (route_name == 'logout') {
                    EventBus.$emit('resetToken')
                    return this.logout()
                } else {
                    if (params) {
                        EventBus.$emit(params.eventbus_call, params.params)
                    }
                    if (route_name == 'parcel-list') {
                        let parcel = this.getLocalItem();
                        parcel.searchText = this.searchText
                        localStorage.setItem('parcel', JSON.stringify(parcel))
                    }
                    return this.$router.push({name: route_name})
                }
            },
            async qrCreate() {
                let localItem = this.getLocalItem()
                if (!localItem.QRref) {
                    let QRref = this.randomRefQR()
                    localItem.QRref = QRref
                    localStorage.setItem('parcel', JSON.stringify(localItem))
                }
                let itemSelected = JSON.parse(localStorage.getItem('parcel')).itemSelected

                itemSelected.forEach(function (su_runno) {
                    axios.post('/SaveReceiveItem', {
                        su_runno: su_runno,
                        sgc_ref: localItem.QRref,
                        nt_runno: localItem.nt_runno,
                        username: localItem.user_id
                    })
                        .then(res => {
                            console.log('qrCreate', res.data)
                        })
                })

                this.valueQR = 'http://localhost:8080/#/cus-receive/' + localItem.QRref
                this.dialog_qr = true
            }
        }
    }
</script>

<style scoped>
    #signature {
        border: double 3px transparent;
        /*border-radius: 10px;*/
        background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
    }
</style>
